import BeelditDateTimeInput from "@beeldit/core/components/BeelditDateTimeInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { Plus, Trash, Lock } from "@phosphor-icons/react";
import { t } from "i18next";

const config = {
  modelName: "cash-reconciliation",
  modelPluralName: "cash-reconciliations",
  endpoint: "cash-reconciliations",
  // Tamaño intermedio (no fullscreen)
  modalFullScreen: false,
  tableConfig: {
    index: null,
    actions: [
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Lock size={20} />,
        allowed: true,
        show: (element: any) => !element.closed_at,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "opened_at",
        label: "opening_date",
        key: "opened_at",
        type: "datetime",
        show: true,
        allowOrder: true,
      },
      {
        name: "opening_amount",
        label: "opening_amount",
        key: "opening_amount",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      },
      {
        name: "closed_at",
        label: "closing_date",
        key: "closed_at",
        type: "datetime",
        show: true,
        allowOrder: true,
      },
      {
        name: "closing_amount",
        label: "closing_amount",
        key: "closing_amount",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      },
    ],
    pagination: { enabled: true, back: true },
  },
  filterConfig: {
    type: "object",
    properties: {
      date_from: { type: "string", title: "Fecha de inicio", format: "date" },
      date_to: { type: "string", title: "Fecha final", format: "date" },
      search: { type: "string", title: "Búsqueda" },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      date_from: {
        "ui:options": { label: "Fecha de inicio", placeholder: "Fecha desde" },
      },
      date_to: {
        "ui:options": { label: "Fecha final", placeholder: "Fecha hasta" },
      },
      search: { "ui:options": { label: "Búsqueda", placeholder: "Buscar..." } },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    required: ["opened_at", "opening_amount"],
    properties: {
      opened_at: {
        type: "string",
        title: t("opening_date"),
        format: "date-time",
      },
      opening_amount: {
        type: "number",
        title: t("opening_amount"),
        minimum: 0,
        default: 0,
      },
      closed_at: {
        type: ["string", "null"],
        title: t("closing_date"),
        format: "date-time",
      },
      closing_amount: {
        type: ["number", "null"],
        title: t("closing_amount"),
        minimum: 0,
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: { disabled: false, className: "btn btn-info" },
      norender: true,
    },
    opened_at: { "ui:widget": BeelditDateTimeInput },
    closed_at: { "ui:widget": BeelditDateTimeInput },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            { name: "opened_at", cols: "col-6" },
            { name: "opening_amount", cols: "col-4 offset-2" },
            { name: "closed_at", cols: "col-6" },
            { name: "closing_amount", cols: "col-4 offset-2" },
          ],
        ],
      },
    ],
  },
};

export default config;
